export const company = Object.freeze({
  legalName: "PPMC",
  tradingName: "Ecotimbre",
  legalForm: "Société par actions simplifiée (SAS)",
  capital: "1 000 €",
  registration: "882 086 952 R.C.S. Paris",
  siren: "882 086 952",
  euid: "FR7501.882086952",
  president: "Marc Uzan",
  registeredOffice: "2 bis rue Nicolas Houël, 75005 Paris",
  contactAddress: "16 rue Raymonde Salez, 93260 Les Lilas",
  email: "murcii26@yahoo.fr",
  phones: [
    { display: "06 63 82 23 53", href: "+33663822353" },
    { display: "06 03 02 50 55", href: "+33603025055" },
  ],
  openingHours: "Du lundi au vendredi, de 08h00 à 20h00",
});
